<template>
	<div>
        <ul class="list-inline polity float-none float-md-right mb-0">
            <li class="list-inline-item border-0 m-0" v-if="fixed">
                <div class="dropdown b-dropdown">
                    <a href="#" class="dropdown-toggle font-weight-bold" :class="{active: openLanguages}" @click.prevent="openLanguages=!openLanguages" @mouseenter="showTxtLanguage=true" @mouseleave="showTxtLanguage=false" data-toggle="dropdown" v-click-outside="()=>{openLanguages=false}">
                        <i class="ms-Icon ms-Icon--World pr-1 align-middle"></i>
                        <span v-if="showTxtLanguage || openLanguages">{{txtLanguage}}</span>
                        <span class="text-uppercase" v-else>{{language}}</span>
                    </a>
                    <div class="dropdown-menu" x-placement="top-start" :class="{show: openLanguages}">
                        <a class="dropdown-item" @click.prevent="changeLanguage(lng.id)" href="#" v-for="lng in languages" v-bind:key="lng.id" v-bind:value="lng.id">{{ lng.desc }}</a>
                    </div>
                </div>
            </li>
            <li class="list-inline-item m-0 font-weight-bold" v-if="!this.$Params.isMobile"><a href="#avisolegal" @click.prevent="polity"><u>{{ $t('avisolegal') }}</u></a></li>
            <li class="list-inline-item m-0 font-weight-bold" v-if="!this.$Params.isMobile"><a href="#privacidad" @click.prevent="polity"><u>{{ $t('privacidad') }}</u></a></li>
            <li class="list-inline-item m-0 font-weight-bold" v-if="!this.$Params.isMobile"><a href="#politica" @click.prevent="polity"><u>{{ $t('politica') }}</u></a></li>
            <li class="list-inline-item m-0 font-weight-bold" v-if="this.$Params.isMobile">
                <div class="dropdown b-dropdown">
                    <a href="#" class="dropdown-toggle font-weight-bold" @click.prevent="openConditions=!openConditions" data-toggle="dropdown" v-click-outside="()=>{openConditions=false}">
                        <u>Condiciones legales</u>
                    </a>
                    <div class="dropdown-menu" x-placement="top-start" :class="{show: openConditions}" style="right: 0;">
                        <a class="dropdown-item" href="#avisolegal" @click.prevent="polity">{{ $t('avisolegal') }}</a>
                        <a class="dropdown-item" href="#privacidad" @click.prevent="polity">{{ $t('privacidad') }}</a>
                        <a class="dropdown-item" href="#politica" @click.prevent="polity">{{ $t('politica') }}</a>
                    </div>
                </div>
            </li>
        </ul>
           
        <mmModal ref="modalPolity" :title="titlePolicy" :textClose="$i18n.t('cerrar')" size="lg">
            <div class="d-block text-center">
                <span v-html="txtPolicy"></span>
            </div>
        </mmModal>
        
    </div>
</template>

<script>
    import { textsService } from '@/api/texts';
    import mmModal from '@mysummar/summar-vue/src/components/mmModal.vue'
    import { localize } from "vee-validate";
    import { langValidate } from '@/_helpers/lang/localize';
    import { languageUtil } from '@/_utils/languageUtil';

    export default {
        name: 'FooterLinks',
        props: {
            fixed: Boolean
        },
        components: {
            mmModal
        },
        data() {
            return {
                titlePolicy : '',
                txtPolicy : '',
                txtLanguage: '',
                language : '',
                languages: [],
                openLanguages: false,
                showTxtLanguage: false,
                openConditions: false
            }
        },
        methods: {
            async polity(e) {
                let option = e.currentTarget.getAttribute('href').replace('#', '');
                this.txtPolicy = await textsService.polity(option);
                this.titlePolicy = this.$i18n.t(option);
                this.$refs.modalPolity.show();
            },
            changeLanguage(lang) {
                this.setLanguage(lang);
                this.openLanguages = false;
                this.language = lang;
            },
            setLanguage(lang) {
                this.$i18n.locale = lang;
                localize(lang, langValidate[lang]);
                localStorage.setItem('lang-active-pdoc', lang);
                this.txtLanguage = this.languages.find(x=>x.id===lang).desc;
                let titlePortal = this.$Params.titulo ? this.$Params.titulo : this.$i18n.t('portalDoc');
                
                document.title = titlePortal;
                this.$store.commit('setTitle', titlePortal)
            }
        },
        async mounted() {
            this.languages = languageUtil.getLanguages();

            //1 se mira el language que viene de la configGeneral
            this.language = this.languages[0].id;
            
            //2 se mira si en la URL hay algun idioma configurado
            if (typeof this.$route.query.lng !== undefined && this.languages.some(x => x.id === this.$route.query.lng))
                this.language = this.$route.query.lng;

            //3 se mira si hay algo en localStorage
            let langStorage = localStorage.getItem('lang-active-pdoc');
            if(langStorage!=null && this.languages.some(x => x.id === langStorage)) this.language = langStorage;

            this.setLanguage(this.language);
        }
    }
</script>